import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import dayjs from "dayjs";
import { RequestedProceduresByProfessionalFilters } from "./RequestedProceduresByProfessionalFilters";
import { RequestedProceduresByProfessionalTable } from "./RequestedProceduresByProfessionalTable";

export function RequestedProceduresByProfessional() {
	const [startDate, setStartDate] = useState(dayjs().add(-2, "year").format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
	/*
    const [youngerAge, setYoungerAge] = useState<number>();
    const [olderAge, setOlderAge] = useState<number>();
    const [professionalId, setProfessionalId] = useState<number>();
    const [professionals, setProfessionals] = useState<User[]>([]);
    */
	//const [dashboard, setDashboard] = useState<MedicalAttendanceDashboardData>();

	async function fetchDashboard() {
		//setDashboard(await getNonSpecializedMedicalAttendanceDashboard({ uf, ibgeCode, startDate, endDate, youngerAge, olderAge, professionalId }));
	}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<RequestedProceduresByProfessionalFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={() => {}}
						setOlderAge={() => {}}
						setProfessionalId={() => {}}
						professionals={[]}
						handleFilter={fetchDashboard}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<RequestedProceduresByProfessionalTable />
				</Col>
			</Row>
		</>
	);
}
